



























































































































































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import AuthModule from "@/store/auth";
import OrderModule from "@/store/order";
import RestaurantModule from "@/store/restaurant";
import RestaurantMenuList from "@/components/RestaurantMenuList.vue";
import FormModal from "@/components/forms/FormModal.vue";
import { OrderDetail, Menu, OrderType } from "@/api/api";
import { Prefectures } from "@/constants";
import moment from "moment";
import { CartEditStatus } from "@/types";
import { ja } from "vuejs-datepicker/dist/locale";
import { isArray } from "util";
import { OrdersApi } from "../../services/api-service";
import { filterUniqueOrderDetailsByuuid, truncate } from "../../utils/Util";

@Component({
  components: {
    RestaurantMenuList,
    FormModal,
  },
})
export default class ROrderEditForm extends Vue {
  private mounted() {
    OrderModule.commitEditStatus(CartEditStatus.Edit);
    this.setCurrentOrder();
  }

  private get me() {
    return AuthModule.me;
  }

  private get Prefectures() {
    return Prefectures;
  }

  private get menus() {
    return RestaurantModule.menus;
  }

  private get newOrder() {
    const newOrder = OrderModule.newOrders.find(order => {
      return order.restaurantUuid === this.me?.uuid;
    });
    if (!newOrder) {
      return null;
    }
    return newOrder;
  }

  private get editStatus() {
    return OrderModule.editStatus;
  }

  private get EditStatus() {
    return CartEditStatus;
  }

  private get moment() {
    return moment;
  }

  private get OrderType() {
    return OrderType;
  }

  private get ja() {
    return ja;
  }

  private get order() {
    return OrderModule.order;
  }

  private truncateName(name: string) {
    const len = 18;
    return truncate(name, len);
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private menuWithCounters: any = [];

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private form: any = {
    orderer: {
      name: "",
      phoneNumber: "",
    },
    shippingAddress: {
      postalCode: "",
      prefecture: "",
      city: "",
      addressLine1: "",
      addressLine2: undefined,
    },
    deliveryDate: null,
    deliveryDateTime: null,
    orderType: undefined,
    user: undefined,
  };

  private mergeCounter(menus: Menu[], orderDetails: OrderDetail[]) {
    this.menuWithCounters = menus.map(menu => {
      const targetOrderDetail = orderDetails.find(orderDetail => {
        return orderDetail.menuUuid === menu.uuid;
      });
      if (targetOrderDetail) {
        return { ...menu, amount: targetOrderDetail.quantity };
      }
      return { ...menu, amount: 0 };
    });
  }

  @Watch("order")
  @Watch("menus")
  private setCurrentOrder() {
    if (!this.order) {
      return;
    }
    if (this.order?.user) {
      this.form.user = this.order.user;
    }
    if (this.order?.orderer) {
      this.form.orderer = this.order.orderer;
    }
    if (this.order?.shippingAddress) {
      this.form.shippingAddress = this.order.shippingAddress;
    }
    if (this.order?.deliveryDate) {
      this.form.deliveryDate = this.order.deliveryDate;
    }
    // TODO: add set deliveryDateTime
    if (this.order?.orderType) {
      this.form.orderType = this.order.orderType;
    }
    if (this.order?.deliveryDate) {
      this.form.deliveryDate = new Date(this.order.deliveryDate);
      this.form.deliveryDateTime = {
        mm: moment(this.order.deliveryDate).format("mm"),
        HH: moment(this.order.deliveryDate).format("HH"),
      };
    }
    if (isArray(this.order.orderDetails) && this.order.orderDetails.length > 0) {
      this.mergeCounter(this.menus, this.order.orderDetails);
    }

    OrderModule.commitNewOrders([this.order]);
  }

  @Watch("menuWithCounters", { deep: true })
  private setQuantity() {
    const replaceOrderDetails: OrderDetail[] = [];
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const newOrderDetails: any[] = [];

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    this.menuWithCounters.forEach((menu: any) => {
      if (!this.order) {
        return;
      }
      if (isArray(this.order?.orderDetails) && this.order.orderDetails.length > 0) {
        if (!this.order) {
          return;
        }
        this.order.orderDetails.forEach(orderDetail => {
          if (menu.uuid === orderDetail.menuUuid) {
            replaceOrderDetails.push({ ...orderDetail, quantity: menu.amount });
          } else if (menu.amount > 0) {
            newOrderDetails.push({
              menuUuid: menu.uuid,
              quantity: menu.amount,
              menu,
            });
          }
        });
      }
    });

    const mergeOrderDetails = replaceOrderDetails;
    newOrderDetails.forEach(orderDetail => {
      mergeOrderDetails.push(orderDetail);
    });

    const filteredNewOrderDetails = filterUniqueOrderDetailsByuuid(mergeOrderDetails);
    OrderModule.commitNewOrder(Object.assign(this.order, { orderDetails: filteredNewOrderDetails }));
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private sumTotalQuantity(orderDetails: any) {
    let sum = 0;
    orderDetails.forEach((detail: OrderDetail) => {
      sum += detail?.quantity ? detail?.quantity : 0;
    });
    return sum;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private sumSubtotalPrice(orderDetails: any[]) {
    let sum = 0;
    orderDetails.forEach((detail: OrderDetail & { menu: Menu }) => {
      sum += detail.menu.price * (detail?.quantity ? detail.quantity : 0);
    });
    return sum;
  }

  private removeItem(orderDetail: OrderDetail & { menu: Menu }) {
    OrderModule.commitRemoveOrderDetail(orderDetail);
  }

  private confirm() {
    OrderModule.commitEditStatus(CartEditStatus.Confirm);
    window.scrollTo(0, 0);
  }

  private backEdit() {
    OrderModule.commitEditStatus(CartEditStatus.Edit);
    window.scrollTo(0, 0);
  }

  private async submit() {
    // eslint-disable-next-line prettier/prettier
    if (!this.form.deliveryDate === null || !this.form.deliveryDateTime === null || !this.order?.uuid) {
      return;
    }
    try {
      const buildedDesiredDeliveryTime = moment(this.form.deliveryDate)
        .set("hour", this.form.deliveryDateTime?.HH)
        .set("minute", this.form.deliveryDateTime?.mm);
      const updateOrder = Object.assign(this.newOrder, this.form, {
        deliveryDate: buildedDesiredDeliveryTime,
      });

      // eslint-disable-next-line
      const orderRes = await OrdersApi.instance.patchOrder(this.order?.uuid!, updateOrder);
      window.scrollTo(0, 0);
    } catch (err) {
      console.log(err);
    }
  }

  // ここからモーダル//
  private testShow() {
    (this.$refs.test as FormModal).CtestShow();
    this.submit();
  }
  // ここまでモーダル//
}
